module.exports = __webpack_public_path__ + "static/media/Table2_Before.24d78ef4.jpg";